<template>
  <AuthenticatedLayout>
    <el-row :gutter="20" class="dashboard-summary">
        <!-- Tarefas em Andamento -->
        <el-col :xs="24" :md="6">
          <el-card class="summary-card in-progress">
            <div class="summary-content">
              <div class="summary-icon">
                <el-icon><document /></el-icon>
              </div>
              <div class="summary-text">
                <p class="summary-number">{{ stats.inProgress }}</p>
                <p class="summary-label">Tarefas em Andamento</p>
              </div>
            </div>
          </el-card>
        </el-col>
      
        <!-- Tarefas Concluídas -->
        <el-col :xs="24" :md="6">
          <el-card class="summary-card completed">
            <div class="summary-content">
              <div class="summary-icon">
                <el-icon><check /></el-icon>
              </div>
              <div class="summary-text">
                <p class="summary-number">{{ stats.completed }}</p>
                <p class="summary-label">Tarefas Concluídas</p>
              </div>
            </div>
          </el-card>
        </el-col>
      
        <!-- Tarefas Atrasadas -->
        <el-col :xs="24" :md="6">
          <el-card class="summary-card overdue">
            <div class="summary-content">
              <div class="summary-icon">
                <el-icon><warning /></el-icon>
              </div>
              <div class="summary-text">
                <p class="summary-number">{{ stats.overdue }}</p>
                <p class="summary-label">Tarefas Atrasadas</p>
              </div>
            </div>
          </el-card>
        </el-col>
      
        <!-- Total de Tarefas -->
        <el-col :xs="24" :md="6">
          <el-card class="summary-card total">
            <div class="summary-content">
              <div class="summary-icon">
                <el-icon><folder /></el-icon>
              </div>
              <div class="summary-text">
                <p class="summary-number">{{ stats.total }}</p>
                <p class="summary-label">Total de Tarefas</p>
              </div>
            </div>
          </el-card>
        </el-col>
    </el-row>

    <!-- Gráficos -->
    <el-row :gutter="20" class="charts">
      <el-col :xs="24" :md="8">
        <el-card>
            <h3>Distribuição por Estágio</h3>          
            <BarChart 
                v-if="charts.stages.length > 0" 
                :data="charts.stages"
            />
        </el-card>
      </el-col>
      <el-col :xs="24" :md="5">
        <el-card>
            <h3>Urgência das Tarefas</h3>
            <PieChart
                v-if="charts.urgency.length > 0" 
                :data="charts.urgency" 
            />
        </el-card>
      </el-col>
      <el-col :xs="24" :md="11">
        <el-card>
            <h3>Tarefas por clientes</h3>
            <PieChart
                v-if="charts.clients.length > 0" 
                :data="charts.clients" 
            />
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :xs="24" :md="12">
        <!-- Tabela Detalhada -->
        <el-card>
          <h3>Tarefas que merecem sua atenção</h3>
          <el-table
          :data="tasks"
          border
          stripe
          style="width: 100%"
          height="350"
        >
          <el-table-column label="Tarefa">
            <template #default="{ row }">
              <a class="link-task" @click="goToTask(row.id, row.slug)">                                  
                  #{{ row.id }} | {{ row.title }} <br />
                  <el-tag type="danger" v-if="row.deadline.overdue">Atrasada</el-tag>
              </a>
            </template>
          </el-table-column>
          <el-table-column
            prop="responsible_name"
            label="Responsável"
            sortable
          ></el-table-column>
          <el-table-column
            prop="start_date"
            label="Data de inicio"
            sortable      
          ></el-table-column>
          <el-table-column
            prop="expected_date"
            label="Entregar até"
            sortable       
          ></el-table-column>          
          <el-table-column
            prop="stage_name"
            label="Estágio"
            sortable       
          ></el-table-column>                    
        </el-table>
        </el-card>
      </el-col>
      <el-col :xs="24" :md="12">
        <!-- Tabela Detalhada -->
        <el-card>
          <h3>Produtividade</h3>
          <el-table
          :data="productivityData"
          border
          stripe
          style="width: 100%"
          height="350"
        >
          <el-table-column
            prop="name"        
            label="Usuário"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="tasks.total"
            label="Tarefas Totais"
            sortable
          ></el-table-column>
          <el-table-column
            prop="tasks.completed"
            label="Concluídas"
            sortable      
          ></el-table-column>
          <el-table-column
            prop="tasks.inProgress"
            label="Em Andamento"
            sortable       
          ></el-table-column>
          <el-table-column
            prop="tasks.overdue"
            label="Atrasadas"
            sortable
          ></el-table-column>
          <el-table-column
            prop="averageProductivity"
            label="Produtividade Média"
            sortable       
          ></el-table-column>
          <el-table-column
            prop="tasks.riskIndicators"
            label="Indicadores de Risco"
            width="300"
          >
            <template #default="{ row }">
              <el-tag
                v-for="(risk, index) in row.riskIndicators"
                :key="index"
                type="danger"
                effect="dark"
              >
                {{ risk }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
        </el-card>
      </el-col>
    </el-row>

    
  </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from "@/layouts/AuthenticatedLayout.vue";
import BarChart from "@/components/BarChart.vue";
import PieChart from "@/components/PieChart.vue";

import { getAccountResume, getUsersResume } from '@/services/dashboardService';

export default {
    name: 'DashboardView',
    components: {
        AuthenticatedLayout,
        BarChart,
        PieChart
    },
  data() {
    return {
      stats: {
        inProgress: 12,
        completed: 30,
        overdue: 5,
        total: 47,
      },
      charts: {
        stages: [],
        urgency: [],
        clients: []
      },
      productivityData: [],
      tasks: []
    };
  },
  mounted() {
    this.getAccountResume();
    this.getUsersResume();
  },
  methods: {
    async getAccountResume() {
      try {
        const response = await getAccountResume();
        
        this.stats = response.resume;

        this.charts.stages = [
            { name: "A Fazer", value: this.stats.todo, color: "#3498db" }, // Azul
            { name: "Fazendo", value: this.stats.inProgress, color: "#f39c12" }, // Laranja
            { name: "Concluído", value: this.stats.completed, color: "#2ecc71" }, // Verde
            { name: "Pendente", value: this.stats.pending, color: "#e74c3c" }, // Vermelho
            { name: "Em validação", value: this.stats.validating, color: "#9b59b6" }, // Roxo
            { name: "Arquivado", value: this.stats.archived, color: "#95a5a6" }, // Cinza
        ];

        this.charts.urgency = [
          { name: "Baixa", value: this.stats.priority.low },
          { name: "Média", value: this.stats.priority.medium },
          { name: "Alta", value: this.stats.priority.high },
        ]

        this.charts.clients = this.stats.tasks_client;

        this.tasks = this.stats.tasks;

        console.warn(":::: CHARTS ::::", this.charts)
        console.log("::::: resume ::::: ", this.stats)
      } catch (error) {
        this.$message.error("Erro ao carregar resumo.");
      }
    },

    async getUsersResume() {
      try {
        const response = await getUsersResume();
        
        this.productivityData = response.resume;
        
        console.warn(":::: PRODUCTIVITY ::::", this.productivityData)
        
      } catch (error) {
        this.$message.error("Erro ao carregar resumo.");
      }
    },

    goToTask(id, slug) {
      this.$router.push({
        name: 'TaskDetails',
        params: {
          id: id,
          slug: slug
        }
      })
    }


  },
};
</script>

<style scoped>
.dashboard {
    margin-bottom: 20px;
}
.charts {
    margin-bottom: 20px;
}
.dashboard-summary {
    margin: 20px 0;
}
  
  .summary-card {
    display: flex;
    align-items: center;
    padding: 20px;
    border-radius: 10px;
  }
  
  .summary-content {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  
  .summary-icon {
    font-size: 60px;
    opacity: 0.4;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .summary-text {
    display: flex;
    flex-direction: column;
    text-align: right;
    flex: 1;
  }
  
  .summary-number {
    font-size: 2.5rem;
    font-weight: bold;
    margin: 0;
  }
  
  .summary-label {
    font-size: 1rem;
    color: #666;
  }
  
  .summary-card.in-progress {
    background-color: #f0f9ff;
    color: #3b82f6;
  }
  
  .summary-card.completed {
    background-color: #f0fff4;
    color: #22c55e;
  }
  
  .summary-card.overdue {
    background-color: #fff7f0;
    color: #f97316;
  }
  
  .summary-card.total {
    background-color: #f9f9f9;
    color: #64748b;
  }
  .link-task {
    font-weight: bold;
    cursor: pointer;
  }
</style>
